
  (function(){
    const v = document.getElementById('heroVid');
    if(!v) return;
    v.muted = true;
    v.addEventListener('playing', ()=>v.classList.add('playing'));
    const tryPlay = () => v.play().catch(()=>{});
    v.addEventListener('loadeddata', tryPlay);
    document.addEventListener('click', tryPlay, {once:true});
    document.addEventListener('touchstart', tryPlay, {once:true});
    tryPlay();
  })();

  const io = new IntersectionObserver(es=>{
    es.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
  },{threshold:.15});
  document.querySelectorAll('.rv').forEach(el=>io.observe(el));

  // ---------- BearDrips Lab loader ----------
  (function(){
    const loader = document.getElementById('loader');
    const bar = document.getElementById('lbar');
    const pct = document.getElementById('lpct');
    const status = document.getElementById('lstatus');
    if(!loader || !bar || !pct || !status){ document.body.classList.add('ready'); return; }
    const LCH = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ*#%&';
    const letters = loader.querySelectorAll('.lab .ll');
    letters.forEach(el=>el.dataset.ch = el.textContent);
    let labDone = false;
    function labScramble(){
      letters.forEach((el,i)=>{
        let frame = 0;
        const lockAt = Math.floor((360 + i*90)/40);
        const t = setInterval(()=>{
          frame++;
          if(frame >= lockAt || labDone){
            el.textContent = el.dataset.ch;
            clearInterval(t);
          }else{
            el.textContent = LCH[Math.floor(Math.random()*LCH.length)];
          }
        }, 40);
      });
    }
    labScramble();
    const labLoop = setInterval(labScramble, 2400);

    // animated LOADING dots
    let dots = 0;
    status.textContent = 'LOADING';
    const dTimer = setInterval(()=>{
      dots = (dots+1) % 4;
      status.textContent = 'LOADING' + '.'.repeat(dots);
    }, 380);

    let p = 0;
    const tick = setInterval(()=>{
      p += Math.random()*14 + 6;
      if(p >= 100){
        p = 100; clearInterval(tick); clearInterval(dTimer); clearInterval(labLoop);
        labDone = true;
        status.textContent = 'READY';
        setTimeout(()=>{
          loader.classList.add('done');
          document.body.classList.add('ready');
          setTimeout(startScramble, 500);
          setTimeout(()=>loader.remove(), 1100);
        }, 380);
      }
      bar.style.width = p + '%';
      pct.textContent = Math.floor(p) + '%';
    }, 150);
  })();

  // ---------- scroll progress ----------
  const sbar = document.getElementById('sbar');
  if(sbar) window.addEventListener('scroll', ()=>{
    const d = document.documentElement.scrollHeight - window.innerHeight;
    sbar.style.transform = 'scaleX(' + (d>0 ? window.scrollY/d : 0) + ')';
  }, {passive:true});

  // ---------- cursor glow ----------
  (function(){
    const glow = document.getElementById('glow');
    if(!glow || window.matchMedia('(pointer:coarse)').matches){ if(glow) glow.remove(); return; }
    let tx=innerWidth/2, ty=innerHeight/2, x=tx, y=ty;
    addEventListener('mousemove', e=>{ tx=e.clientX; ty=e.clientY; });
    (function loop(){
      x += (tx-x)*.08; y += (ty-y)*.08;
      glow.style.left = x+'px'; glow.style.top = y+'px';
      requestAnimationFrame(loop);
    })();
  })();

  // ---------- card tilt ----------
  if(!window.matchMedia('(pointer:coarse)').matches){
    document.querySelectorAll('.tilt').forEach(card=>{
      card.addEventListener('mousemove', e=>{
        const r = card.getBoundingClientRect();
        const rx = ((e.clientY - r.top)/r.height - .5) * -7;
        const ry = ((e.clientX - r.left)/r.width - .5) * 7;
        card.style.transform = 'perspective(800px) rotateX('+rx+'deg) rotateY('+ry+'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', ()=>{ card.style.transform = ''; });
    });
  }

  // ---------- magnetic buttons ----------
  if(!window.matchMedia('(pointer:coarse)').matches){
    document.querySelectorAll('.btn').forEach(b=>{
      b.addEventListener('mousemove', e=>{
        const r = b.getBoundingClientRect();
        const mx = (e.clientX - r.left - r.width/2) * .25;
        const my = (e.clientY - r.top - r.height/2) * .35;
        b.style.transform = 'translate(' + mx + 'px,' + my + 'px)';
      });
      b.addEventListener('mouseleave', ()=>{ b.style.transform=''; });
    });
  }

  // ---------- BEARDRIPS letter scramble ----------
  const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ*#%&';
  function scrambleEl(el, target, delay){
    let frame = 0;
    const lockAt = Math.floor(delay/45);
    const t = setInterval(()=>{
      frame++;
      if(frame >= lockAt){
        el.textContent = target;
        clearInterval(t);
      }else{
        el.textContent = CHARS[Math.floor(Math.random()*CHARS.length)];
      }
    }, 45);
  }
  function startScramble(){
    document.querySelectorAll('.hero-title h1 .l').forEach((el,i)=>{
      const target = el.dataset.ch;
      scrambleEl(el, target, 500 + i*170);
    });
  }
  // store target letters + hover re-scramble per letter
  document.querySelectorAll('.hero-title h1 .l').forEach(el=>{
    el.dataset.ch = el.textContent;
    el.addEventListener('mouseenter', ()=>scrambleEl(el, el.dataset.ch, 350));
  });

  // mobile menu
  (function(){
    const b = document.getElementById('mbtn');
    const m = document.getElementById('mmenu');
    if(!b || !m) return;
    b.addEventListener('click', ()=>{
      const open = m.classList.toggle('open');
      b.classList.toggle('open', open);
      b.setAttribute('aria-expanded', open);
    });
    m.querySelectorAll('a').forEach(a=>a.addEventListener('click', ()=>{
      m.classList.remove('open'); b.classList.remove('open'); b.setAttribute('aria-expanded','false');
    }));
  })();

  // reviews slider
  (function(){
    const track = document.getElementById('revs');
    if(!track) return;
    const step = () => (track.querySelector('.rev')?.offsetWidth || 340) + 16;
    document.getElementById('rnext').addEventListener('click', ()=>track.scrollBy({left:step(),behavior:'smooth'}));
    document.getElementById('rprev').addEventListener('click', ()=>track.scrollBy({left:-step(),behavior:'smooth'}));
    let auto = setInterval(()=>{
      if(track.scrollLeft + track.clientWidth >= track.scrollWidth - 10){
        track.scrollTo({left:0,behavior:'smooth'});
      }else{
        track.scrollBy({left:step(),behavior:'smooth'});
      }
    }, 4200);
    ['pointerdown','touchstart','wheel'].forEach(ev=>track.addEventListener(ev, ()=>{clearInterval(auto);}, {once:true,passive:true}));
  })();


  // AJAX add-to-cart: instant badge update, no page reload needed
  (function(){
    const form = document.querySelector('form[action*="/cart/add"]');
    if(!form) return;
    form.addEventListener('submit', async (e)=>{
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const orig = btn.textContent;
      btn.textContent = 'Adding\u2026'; btn.disabled = true;
      try{
        const res = await fetch('/cart/add.js', {method:'POST', body:new FormData(form), headers:{'Accept':'application/json'}});
        if(!res.ok) throw new Error('add failed');
        const cart = await (await fetch('/cart.js')).json();
        const cc = document.getElementById('cartCount');
        if(cc){ cc.textContent = cart.item_count; cc.style.display = cart.item_count > 0 ? 'flex' : 'none'; }
        btn.textContent = 'Added \u2713';
        setTimeout(()=>{ btn.textContent = orig; btn.disabled = false; }, 1600);
      }catch(err){
        btn.textContent = orig; btn.disabled = false;
        form.removeEventListener('submit', arguments.callee);
        form.submit(); // graceful fallback to normal post
      }
    });
  })();
